import MyAccountActionType from '../../common/MyAccountActionType';

const MoveAction = {
  setMoveToPlan: label => ({ type: MyAccountActionType.SET_MOVE_TO_PLAN, label })
};

export default MoveAction;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/MoveAction.js
 **/